module.exports = __webpack_public_path__ + "static/media/apply-error.11edae5f.png";